<template>
  <div>
    <v-app-bar fixed elevation="1" color="white">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn depressed rounded @click="newSchool">Salvar</v-btn>
    </v-app-bar>
    <div class="mt-5 pt-5"></div>
    <v-container class="mt=5 pt-5">
      <v-form ref="form">
        <v-row>
          <v-col>
            <h2>Identificação da Escola</h2>
            <v-text-field
              v-model="school.name"
              label="Nome da Escola"
              :rules="itemRules"
            ></v-text-field>

            <v-radio-group label="Vínculo" v-model="school.type" row>
              <v-radio label="Estadual" :value="false"></v-radio>
              <v-radio label="Municipal" :value="true"></v-radio>
            </v-radio-group>

            <!-- Não tá pegando os dados -->
            <v-autocomplete
              v-model="school.city"
              :items="cities"
              item-text="name"
              item-value="id"
              label="Município"
              :rules="itemRules"
            ></v-autocomplete>

            <v-text-field
              v-model="school.director"
              label="Nome do diretor"
              :rules="itemRules"
            ></v-text-field>

            <v-text-field
              v-model="school.address"
              label="Endereço da escola"
              :rules="itemRules"
            ></v-text-field>
            <v-text-field
              v-model="school.pupilsNumber"
              type="number"
              min="0"
              label="Numero de alunos"
              :rules="itemRules"
            ></v-text-field>
            <v-text-field
              v-model="school.teachersNumber"
              type="number"
              min="0"
              label="Numero de professores"
              :rules="itemRules"
            ></v-text-field>
            <v-text-field
              v-model="school.othersProfissionals"
              type="number"
              min="0"
              label="Numero de profisionais da equipe técnica e administrativa"
              :rules="itemRules"
            ></v-text-field>

            <v-card outlined>
              <v-card-text>
                <p>Modalidades de Ensino</p>
                <v-checkbox
                  v-model="school.modalities"
                  label="Ensino infantil"
                  :value="0"
                ></v-checkbox>
                <v-checkbox
                  v-model="school.modalities"
                  label="Ensino fundamental 1° ciclo"
                  :value="1"
                ></v-checkbox>
                <v-checkbox
                  v-model="school.modalities"
                  label="Ensino fundamental 2° ciclo"
                  :value="2"
                ></v-checkbox>
                <v-checkbox
                  v-model="school.modalities"
                  label="Ensino Médio"
                  :value="3"
                ></v-checkbox>
                <v-checkbox
                  v-model="school.modalities"
                  label="Educação de Jovens e Adultos - EJA"
                  :value="4"
                ></v-checkbox>
                <v-checkbox
                  v-model="school.modalities"
                  label="Ensino profissionalizante"
                  :value="5"
                ></v-checkbox>
              </v-card-text>
            </v-card>

            <h2>Infraestrutura da escola</h2>

            <v-radio-group
              label="Numero de sala de aulas"
              v-model="school.classroomsNumber"
              row
            >
              <v-radio label="Até 10" :value="0"></v-radio>
              <v-radio label="de 10 a 20" :value="1"></v-radio>
              <v-radio label="mais de 20" :value="2"></v-radio>
            </v-radio-group>

            <v-switch v-model="school.library" label="Possui biblioteca?" />

            <v-switch
              v-model="school.computersRoom"
              label="Possui sala ou laboratório de informática para os alunos?"
            />

            <v-radio-group
              v-if="school.computersRoom"
              label="Numero de computadores"
              v-model="school.computersQty"
              row
            >
              <v-radio label="Até 5" :value="0"></v-radio>
              <v-radio label="de 5 a 10" :value="1"></v-radio>
              <v-radio label="mais de 10" :value="2"></v-radio>
            </v-radio-group>

            <v-switch
              v-model="school.computersAccess"
              label="Os alunos possuem acesso direto aos computadores (notebooks, PC, tablets) da escola na sala de aula?"
            />

            <v-switch
              v-model="school.internetAccess"
              label="Os alunos possuem acesso a internet através de equipamentos da escola?"
            />

            <v-switch
              v-model="school.multimidiaRoom"
              label="A escola tem sala para os recursos de mídia/comunicação"
            />
            <v-text-field
              v-if="school.multimidiaRoom"
              v-model="school.multimidiaDescription"
              label="Descreva os recursos multimídias"
              :rules="itemRules"
            ></v-text-field>

            <v-switch
              v-model="school.sportsCourt"
              label="Possui quadra de esportes?"
            />

            <v-switch v-model="school.auditorium" label="Possui auditório?" />

            <v-radio-group
              v-if="school.auditorium"
              label="Numero de computadores"
              v-model="school.auditoriumCapacity"
              row
            >
              <v-radio label="Até 50" :value="0"></v-radio>
              <v-radio label="de 50 a 100" :value="1"></v-radio>
              <v-radio label="mais de 100" :value="2"></v-radio>
            </v-radio-group>

            <h2>Informações sobre iniciacao científica</h2>

            <v-switch
              v-model="school.scientificResearch"
              label="A escola realiza atividades de iniciação científica com os alunos?"
            />

            <v-text-field
              v-if="school.scientificResearch"
              v-model="school.scientificResearchDescription"
              label="Descreva brevemente a atividade e identifique o docente responsavel"
              :rules="itemRules"
            ></v-text-field>

            <h2>Eventos escolares</h2>

            <v-switch
              v-model="school.calendar"
              label="A escola possui em seu calendário a realização de eventos?"
            />

            <v-text-field
              v-if="school.calendar"
              v-model="school.calendarDescription"
              label="Liste os eventos, quantos houverem"
              :rules="itemRules"
            ></v-text-field>

            <v-card outlined>
              <v-card-text>
                <v-radio-group
                  label="A escola realiza eventos como:"
                  v-model="school.eventsType"
                >
                  <v-radio
                    label="Feira ou clube de ciência"
                    :value="0"
                  ></v-radio>
                  <v-radio label="Robótica" :value="1"></v-radio>
                  <v-radio label="Olimpíadas de Ciências" :value="2"></v-radio>
                  <v-radio label="Outros" :value="3"></v-radio>
                  <v-text-field
                    v-if="school.eventsType == 3"
                    v-model="school.eventsDescription"
                    label="Descreva o evento"
                    :rules="itemRules"
                  ></v-text-field>
                </v-radio-group>
              </v-card-text>
            </v-card>

            <v-text-field
              v-model="school.responsible"
              label="Nome do responsável do cadastro"
              :rules="itemRules"
            ></v-text-field>

            <v-text-field
              v-model="school.responsibleContact"
              label="Contato do responsável do cadastro"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { cities } from "@/utils";
export default {
  name: "NewSchool",
  created() {
    if (this.$store.state.editSchool["_id"]) {
      this.school = this.$store.state.editSchool;
      this.title = "Visualizar/Editar Escola";
    }
  },
  beforeDestroy() {
    this.$store.commit("setEditSchool", {});
  },
  methods: {
    async newSchool() {
      if (this.$refs.form.validate()) {
        if (this.$store.state.editSchool["_id"]) {
          this.$http
            .put("/schools/" + this.$store.state.editSchool["_id"], this.school)
            .then((response) => {
              this.$store.commit("updateSchool", response.data);
              this.$refs.form.reset();
              this.$router.push("admin");
            });
        } else {
          this.$http.post("/schools", this.school).then((response) => {
            this.$refs.form.reset();
            this.$router.push("admin");
          });
        }
      }
    },
  },
  data() {
    return {
      cities,
      title: "Nova Escola",
      itemRules: [(v) => !!v || "Item Obrigatorio"],
      school: {
        name: "",
        type: null,
        city: "",
        director: "",
        address: "",
        pupilsNumber: null,
        teachersNumber: null,
        othersProfissionals: null,
        modalities: [],
        classroomsNumber: null,
        library: false,
        computersRoom: false,
        computersQty: null,
        computersAccess: false,
        internetAccess: false,
        multimidiaRoom: false,
        multimidiaDescription: "",
        sportsCourt: false,
        auditorium: false,
        auditoriumCapacity: null,
        scientificResearch: false,
        scientificResearchDescription: "",
        calendar: false,
        calendarDescription: "",
        eventsType: null,
        eventsDescription: "",
        responsible: "",
        responsibleContact: "",
      },
    };
  },
};
</script>
